import Cloudprinter from '../../services/CloudprinterService'

const initialState = () => ({
  reorderCause: null,
  reorderDescription: null,
  quantity: null,
  productsQuantity: {},

  productsInfo: {},
  originOrder: {
    items: []
  },
  cpCountries: [],
  shippingAddress: {
    firstName: null,
    lastName: null,
    company: null,
    email: null,
    phone: null,
    country: null,
    state: null,
    city: null,
    street1: null,
    street2: null,
    zip: null,
    customerIdentification: null
  },
  reorderItemsReferences: [],
  cpOrderShipping: [],

  file_storage: null,
  file_cover: {},
  file_book: {},
  file_product: {},
  file_archive: {},
  cp_product_category: null,
  cp_product_sub_category: null,
  cp_product_reference: null,
  cp_product_options: {},
  cp_file: {
    product_url: null,
    archive_url: null,
    cover_url: null,
    book_url: null
  },

  quotes: {},
  product_price: null,
  total_price: 0,
  mode: null,

  cpProductInfo: {},
  stateIsRequired: false,
  priceCheckError: null,
  priceCheckResponse: null,

  cpStates: []
})

const state = initialState()

const actions = {
  updateAll (context, data) {
    context.commit('updateAll', data)
  },

  priceCheck (context, data) {
    let orderItemsForQuote = context.getters['orderItemsForQuote']

    if (!orderItemsForQuote.length) {
      const data = {
        priceCheckError: 'At least one product must be selected',
        priceCheckResponse: null
      }
      context.commit('updatePriceCheckData', data)
      return Promise.reject(new Error('At least one product must be selected'))
    }

    let priceCheckData = {
      'country': context.state.shippingAddress.country,
      'zip': context.state.shippingAddress.zip,
      'items': orderItemsForQuote
    }

    if (context.state.stateIsRequired) {
      priceCheckData.state = context.state.shippingAddress.state
    }

    const priceCheck = Cloudprinter.priceCheck(priceCheckData)

    priceCheck.then(response => {
      // Todo. Remove this condition when CPMAIN-112 is done.
      if (response.data.error) {
        const data = {
          priceCheckError: 'The shipping is not possible. Please, contact support.',
          priceCheckResponse: null
        }
        context.commit('updatePriceCheckData', data)
        return Promise.reject(new Error('The shipping is not possible. Please, contact support.'))
      }

      const originItemsShipmentsOption = context.getters['originItemsShipments']
      let responseData = response.data
      for (let shipment of responseData.shipments) {
        shipment.quotes = shipment.quotes.filter(quote => {
          if (quote.shipping_option === originItemsShipmentsOption[shipment.items[0].reference]) {
            return quote
          }
        })
        if (shipment.quotes.length === 0) {
          const data = {
            priceCheckError: 'The shipping is not possible. Please, contact support.',
            priceCheckResponse: null
          }
          context.commit('updatePriceCheckData', data)
          return Promise.reject(new Error('The shipping is not possible'))
        }
      }

      const data = {
        priceCheckError: null,
        priceCheckResponse: responseData
      }
      context.commit('updatePriceCheckData', data)
    }).catch(error => {
      const data = {
        priceCheckError: error.response.data.error.info,
        priceCheckResponse: null
      }
      context.commit('updatePriceCheckData', data)
    })

    return priceCheck
  }
}

const mutations = {
  updateAll (state, data) {
    for (let key in data) {
      state[key] = data[key]
    }
  },
  updatePriceCheckData (state, data) {
    state.priceCheckError = data.priceCheckError
    state.priceCheckResponse = data.priceCheckResponse
  }
}

const getters = {
  allData: state => {
    return state
  },

  countryName: state => {
    for (let country of state.cpCountries) {
      if (country.country_reference === state.shippingAddress.country) {
        return country.note
      }
    }
  },

  stateName: state => {
    for (let stateItem of state.cpStates) {
      if (stateItem.state_reference === state.shippingAddress.state) {
        return stateItem.note
      }
    }
  },

  shippingAddress: (state, getters) => {
    let shippingData = {
      'type': 'delivery',
      'company': state.shippingAddress.company,
      'firstname': state.shippingAddress.firstName,
      'lastname': state.shippingAddress.lastName,
      'street1': state.shippingAddress.street1,
      'street2': state.shippingAddress.street2,
      'zip': state.shippingAddress.zip,
      'city': state.shippingAddress.city,
      'country': state.shippingAddress.country,
      'email': state.shippingAddress.email,
      'phone': state.shippingAddress.phone,
    }

    if (getters.customerIdentificationIsSupported) {
      shippingData.customer_identification = state.shippingAddress.customerIdentification
    }

    if (state.stateIsRequired) {
      shippingData.state = state.shippingAddress.state
    }

    return shippingData
  },

  orderItemsForQuote: state => {
    let items = []

    for (let orderItem of state.originOrder.items) {
      if (state.reorderItemsReferences.indexOf(orderItem.reference) === -1) {
        continue
      }

      let itemOptions = []

      for (let option of orderItem.options) {
        itemOptions.push({
          'option_reference': option.option_reference,
          'count': option.count
        })
      }

      orderItem.files.forEach((element, index) => {
        orderItem.files[index].md5sum = '_____________NO_MD5_____________'
      })

      items.push({
        'reference': orderItem.reference,
        'product_reference': orderItem.product_reference,
        'count': state.productsQuantity[orderItem.reference],
        'options': itemOptions,
        'type': orderItem.type,
        'files': orderItem.files
      })
    }

    return items
  },

  getQuotes: (state) => {
    let result = {}
    for (let key in state.quotes) {
      for (let item of state.cpOrderShipping[key].items) {
        result[item.reference] = state.quotes[key]
      }
    }

    return result
  },

  orderItemsForOrder: (state, context) => {
    let items = context.orderItemsForQuote
    for (let item of items) {
      item['reorder_cause'] = state.reorderCause
      item['reorder_desc'] = state.reorderDescription
      item['reorder_order_reference'] = state.originOrder.reference
      item['reorder_item_reference'] = item.reference
      item['type'] = item.type
    }

    return items
  },

  originItemsShipments: (state, context) => {
    let result = []
    for (let item of state.originOrder.items) {
      result[item.reference] = item.shipping_option
    }

    return result
  },

  customerIdentificationIsSupported: state => {
    // Todo: Take the countries from the API.
    return ['BR', 'TW'].indexOf(state.shippingAddress.country) !== -1;
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
